import createIcon from '../../createIcon';

/**
 * @component @name PersonAddDisabled
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMjQwMl8xOTczNikiPgo8cGF0aCBkPSJNMTUuNSAxMS4wOTk5QzE3LjcwOTEgMTEuMDk5OSAxOS41IDkuMzA5MDQgMTkuNSA3LjA5OTlDMTkuNSA0Ljg5MDc2IDE3LjcwOTEgMy4wOTk5IDE1LjUgMy4wOTk5QzEzLjI5MDkgMy4wOTk5IDExLjUgNC44OTA3NiAxMS41IDcuMDk5OUMxMS41IDkuMzA5MDQgMTMuMjkwOSAxMS4wOTk5IDE1LjUgMTEuMDk5OVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMy41IDE5LjA5OTlWMTcuMDk5OUMyMy41IDE0Ljc5OTkgMTkuNCAxMy4zOTk5IDE2LjYgMTMuMTk5OUwyMi42IDE5LjA5OTlIMjMuNVpNMTEuOSAxMy41OTk5QzkuNyAxNC4xOTk5IDcuNSAxNS4zOTk5IDcuNSAxNy4wOTk5VjE5LjA5OTlIMTcuNEwyMS40IDIzLjA5OTlMMjIuNyAyMS43OTk5TDEuNyAwLjg5OTkwMkwwLjUgMi4xOTk5TDQuNSA2LjE5OTlWOS4wOTk5SDEuNVYxMS4wOTk5SDQuNVYxNC4wOTk5SDYuNVYxMS4wOTk5SDkuNEwxMS45IDEzLjU5OTlaTTYuNSA5LjA5OTlWOC4xOTk5TDcuNCA5LjA5OTlINi41WiIgZmlsbD0iYmxhY2siLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8yNDAyXzE5NzM2Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PersonAddDisabled = createIcon('PersonAddDisabled', [
  ['g', { clipPath: 'url(#clip0_2402_19736)', key: '1m7qk8' }],
  ['defs', { key: '9ahrjx' }],
]);

export default PersonAddDisabled;
